<template>
  <div>
    <div class="leaderBox" v-if="showOrhide">
      <div class="newtext">新手指引</div>
      <img src="../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
      <img src="../../assets/images/addxnwl.png" class="steps step1" v-if="status==1">
      <img src="../../assets/images/addxnwl1.png" class="steps step2" v-if="status==2">
      <div class="stepbtn" @click="nextStep(status)">
        {{ status == 1 ? "下一步" : status == 2 ? "我知道了" : "我知道了" }}
      </div>
      <div class="bottomTip">
        <el-checkbox v-model="checked">下次不再提示</el-checkbox>
      </div>
    </div>
    <breadcrumb :routerList="[{to:'/chanp/productManage',title:'产品管理'},{title:'产品创建'}]"/>
    <div class="h-content">
      <div class="h-row h-mrt0">
        <div class="h-rowIn">
          <div class="h-rowBox">
            <div class="h-rowCon" style="padding-top: 0.38rem;">
              <div class="h-pieceIn2">
                <div class="h-pieceCon2">
                  <div class="h-formLine weekplandetail16">
                    <el-form :model="zy" label-position="right" ref="zy" :rules="rules"
                             :inline="true" class="demo-ruleForm h-formbLine h-formbLine1">

                      <!--<el-form-item label="业务类型" prop="ywlx" class="h-elformWrap-2">-->
                      <!--    <brselect category="IN_TYPE" :v="zy.ywlx" v-model="zy.ywlx" disabled=""></brselect>-->
                      <!--</el-form-item>-->
                      <el-form-item label="物料编码" class="h-elformWrap-2" prop="wlxhv">
                        <el-input placeholder="请输入" v-model="zy.materialCode" disabled=""></el-input>
                      </el-form-item>

                      <el-form-item label="物料型号" class="h-elformWrap-2" prop="wlxhv">
                        <el-input placeholder="请输入" v-model="zy.wlxh" disabled=""></el-input>
                      </el-form-item>

                      <el-form-item label="基本单位" prop="jbdw" class="h-elformWrap-2">
                        <brselect category="YLUnit" :v="zy.jbdw" v-model="zy.jbdw" disabled=""></brselect>
                      </el-form-item>

                      <!--<el-form-item label="物料组" prop="wlz" class="h-elformWrap-2">-->
                      <!--    <template>-->
                      <!--        <brselectlazy category="YLMaterialGroup" :v="zy.wlz" v-model="zy.wlz" disabled=""></brselectlazy>-->
                      <!--    </template>-->
                      <!--</el-form-item>-->
                      <!--<el-form-item label="旧物料号" class="h-elformWrap-2" prop="jwlh">-->
                      <!--    <el-input placeholder="请输入" v-model="zy.jwlh" disabled=""></el-input>-->
                      <!--</el-form-item>-->

                      <el-form-item label="产品组" prop="cpz" class="h-elformWrap-2">
                        <brselect category="YLProductGroup" :v="zy.cpz" v-model="zy.cpz" disabled=""></brselect>
                      </el-form-item>

                      <!--<el-form-item label="实验室" prop="sys" class="h-elformWrap-2">-->
                      <!--    <brselect category="Laboratory" :v="zy.sys" v-model="zy.sys" disabled=""></brselect>-->
                      <!--</el-form-item>-->

                      <!--<el-form-item label="外部物料组" class="h-elformWrap-2">-->
                      <!--    <el-input placeholder="请输入" v-model="zy.wbwlz" disabled=""></el-input>-->
                      <!--</el-form-item>-->

                      <el-form-item label="税分类" prop="sfl" class="h-elformWrap-2">
                        <brselect category="YLMtlTaxType" :v="zy.sfl" v-model="zy.sfl" disabled=""></brselect>
                      </el-form-item>


                      <!--<el-form-item label="产品注册号" class="h-elformWrap-2">-->
                      <!--    <el-input placeholder="请输入" v-model="zy.cpzch" disabled=""></el-input>-->
                      <!--</el-form-item>-->
                      <!--<el-form-item label="储运条件" class="h-elformWrap-2">-->
                      <!--    <el-input placeholder="请输入" v-model="zy.cytj" disabled=""></el-input>-->
                      <!--</el-form-item>-->
                      <!--<el-form-item label="产地" class="h-elformWrap-2">-->
                      <!--    <el-input placeholder="请输入" v-model="zy.cd" disabled=""></el-input>-->
                      <!--</el-form-item>-->
                      <el-form-item label="产品层次" prop="cpcc" class="h-elformWrap-2">
                        <template>
                          <brselectlazy category="YLProdHierarchy" :v="zy.cpcc" v-model="zy.cpcc"
                                        disabled=""></brselectlazy>
                        </template>
                      </el-form-item>

                      <!--<el-form-item label="生产商" class="h-elformWrap-2">-->
                      <!--    <el-input placeholder="请输入" v-model="zy.scs" disabled=""></el-input>-->
                      <!--</el-form-item>-->
                      <el-form-item label="小微编码" prop="xwbm" class="h-elformWrap-2">
                        <brselect category="YLXW" :v="zy.xwbm" v-model="zy.xwbm" disabled=""></brselect>
                      </el-form-item>

                      <el-form-item label="跨分销链状态" class="h-elformWrap-2">
                        <el-input placeholder="请输入" v-model="zy.chainStatus" disabled="disabled"></el-input>
                      </el-form-item>

                      <el-form-item label="物料类型" class="h-elformWrap-2">
                        <el-input placeholder="请输入" v-model="zy.protype" disabled="disabled"></el-input>
                      </el-form-item>

                      <!--<el-form-item label="物料类型" class="h-elformWrap-2">-->
                      <!--  <el-input placeholder="请输入" v-model="zy.chainStatus" disabled="disabled"></el-input>-->
                      <!--</el-form-item>-->
                      <!--<el-form-item label="生态硬件属性" prop="styjsx" class="h-elformWrap-2">-->
                      <!--    <brselect category="YLEcology" :v="zy.styjsx" v-model="zy.styjsx" disabled=""></brselect>-->
                      <!--</el-form-item>-->
                      <!--<el-form-item label="生态收入" prop="stsr" class="h-elformWrap-2">-->
                      <!--    <brselect category="YLEcologyIn" :v="zy.stsr" v-model="zy.stsr" disabled=""></brselect>-->
                      <!--</el-form-item>-->
                      <!--<el-form-item label="产品有效期" class="h-elformWrap-2">-->
                      <!--    <template>-->
                      <!--        <div class=" block">-->
                      <!--            <el-date-picker-->
                      <!--                    disabled-->
                      <!--                    v-model="zy.youxiaoqi"-->
                      <!--                    type="date"-->
                      <!--                    placeholder=""-->
                      <!--                    value-format="yyyy-MM-dd"-->
                      <!--                    :clearable=false-->
                      <!--            >-->
                      <!--            </el-date-picker>-->
                      <!--        </div>-->
                      <!--    </template>-->
                      <!--</el-form-item>-->
                      <!--<el-form-item label="行业标准描述" class="h-elformWrap-2">-->
                      <!--    <el-input placeholder="请输入" v-model="zy.hybzms" disabled=""></el-input>-->
                      <!--</el-form-item>-->
                      <!--<el-form-item label="创建人账号" class="h-elformWrap-2">-->
                      <!--    <el-input placeholder="请输入" v-model="zy.cjrzh" disabled="disabled"></el-input>-->
                      <!--</el-form-item>-->

                      <el-form-item label="物料组编码" class="h-elformWrap-2">
                        <el-input placeholder="" v-model="zy.mtlGroupCode" disabled="disabled"></el-input>
                      </el-form-item>
                      <el-form-item label="物料组描述" class="h-elformWrap-2">
                        <el-input placeholder="" v-model="zy.mtlGroupName" disabled="disabled"></el-input>
                      </el-form-item>
                      <el-form-item label="规格型号" class="h-elformWrap-2">
                        <el-input placeholder="" v-model="zy.oemDesc" disabled="disabled"></el-input>
                      </el-form-item>
                      <el-form-item label="开票名称" class="h-elformWrap-2">
                        <el-input placeholder="" v-model="zy.spbmjcmtlgroupname" disabled="disabled">
                        </el-input>
                      </el-form-item>

                      <el-form-item label="驳回审批意见" class="h-elformWrap-2" v-if="chongxintijiaoshow">
                        <el-input v-model="zy.shenpiyijian" placeholder="" disabled="disabled"></el-input>
                      </el-form-item>

                      <el-form-item label="服务类型" class="h-elformWrap-2" :rules="[
                                                { required: true, message: '请选择', trigger: 'blur'},
                                              ]">
                        <el-select style="width:2.4rem" :v="zy.serviceProductsType" v-model="zy.serviceProductsType"
                                   placeholder="请选择" clearable>
                          <el-option label="3Q服务类" value="3Q服务类"></el-option>
                          <el-option label="售后增值服务" value="售后增值服务"></el-option>
                          <el-option label="其他" value="其他"></el-option>
                        </el-select>
                      </el-form-item>

                    </el-form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="h-txtCenter h-mrt60">

        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="chongxintijiao" v-if="chongxintijiaoshow">重新提交</el-button>

        <el-button class="h-btn h-bBtn h-bgwhite" @click="fanhui">返回</el-button>
        <el-button class="h-btn h-bBtn h-bggreen" @click="saveToServiceType">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import ss from '../../api/SystemService'
// const cityOptions = ['市场部1', '市场部2', '市场部3', '市场部4'];
export default {
  data() {
    return {
      // 新手引导页
      showOrhide: false,
      status: 1,
      checked: true,
      toshow: "productCreate",
      chongxintijiaoshow: false,
      //ywid
      ywid: null,
      //instid
      instid: null,
      //taskid
      taskid: null,
      YLProdHierarchyList: [],
      YLMaterialGroupList: [],
      qianyeshuju: {},
      //小微编码
      xiaoweibianma: [{
        value: '',
        label: '--请选择--'
      },],
      //生态收入
      shengtaishouru: [{
        value: '',
        label: '--请选择--'
      },],
      //生态硬件属性
      shengtaiyingjianshuxing: [{
        value: '',
        label: '--请选择--'
      },],

      //产品层次
      chanpincengci: [{
        value: '',
        label: '--请选择--'
      },],

      //税分类
      shuifenlei: [{
        value: '',
        label: '--请选择--'
      },],

      //实验室
      shiyanshi: [{
        value: '',
        label: '--请选择--'
      },],

      //产品组
      chanpinzu: [{
        value: '',
        label: '--请选择--'
      },],

      //物料组
      wuliaozu: [{
        value: '',
        label: '--请选择--'
      },],

      //基本单位
      jibendanwei: [{
        value: '',
        label: '--请选择--'
      },],


      //物料id
      chanpinid: '',

      //资料类型名称
      chanpinziliao: 'shangchuanpingzheng',

      ywlxxuanxiang: [
        {
          value: '',
          label: '--请选择--'
        },

        {
          value: 'SH',
          label: '上海OEM'
        }, {
          value: 'HK',
          label: '香港OEM'
        }

      ],


      options1: [{
        value: '选项1',
        label: '渠道1'
      }, {
        value: '选项2',
        label: '渠道2'
      }],
      options2: [{
        value: '选项1',
        label: '分类1'
      }, {
        value: '选项2',
        label: '分类2'
      }],
      options3: [{
        value: '选项1',
        label: '大类1'
      }, {
        value: '选项2',
        label: '大类2'
      }],
      options4: [{
        value: '选项1',
        label: '大类1'
      }, {
        value: '选项2',
        label: '大类2'
      }],
      options5: [{
        value: '选项1',
        label: '型号1'
      }, {
        value: '选项2',
        label: '型号2'
      }],
      zy: {
        ywlx: null,
        wlxh: null,
        wlms: null,
        jbdw: null,
        wlz: null,
        jwlh: null,
        cpz: null,
        sys: null,
        wbwlz: null,
        sfl: null,
        cpzch: null,
        cytj: null,
        cd: null,
        cpcc: null,
        scs: null,
        xwbm: null,
        styjsx: null,
        stsr: null,
        youxiaoqi: null,
        pingzheng: null,
        hybzms: null,
        cjrzh: null,
        shenpiyijian: null,
        serviceProductsType: null
      },
      rules: {}
    }
  },


  //加载页面默认执行
  created() {
    this.showzhezhao()
    var chushucanshu1 = {

      materialCode: this.$router.history.current.query.materialCode,
      xuniwuliao: this.$router.history.current.query.xuniwuliao,
      rowId: this.$router.history.current.query.rowId,

    }
    this.gettableels(chushucanshu1)
    //加载登陆人账号
    this.zy.cjrzh = this._user.usercode;


    //加载配置项
    this.huoquprizhixiang();

  },


  //监听
  watch: {},


  methods: {


    //重新提交
    chongxintijiao() {

      //更新修改的信息
      this.zancunortijiao(3);

      var chongxin = {

        yewuzhujian: this.ywid,
        taskid: this.taskid,

      }

      //重新提交
      ss.chanpin.chongxintijiao(chongxin).then(rd => {

        if (rd.obj == true) {

          this.$msg.msgs(rd.msg)

          //返回
          this.$router.push({path: '/chanp/productManage'});

        }

      })


    },

    //保存服务类型
    saveToServiceType() {
      var serviceType = {
        rowId: this.$router.history.current.query.rowId,
        serviceProductsType: this.zy.serviceProductsType,
      };
      console.log(serviceType);
      ss.chanpin.updateServiceType(serviceType).then(rd => {
        if (rd.f == true) {
          this.$msg.msgs(rd.msg);
          this.fanhui();
          //this.query();
        }
      })
    },


    //加载配置项
    gettableels(q) {
      console.log("123123123123123123");
      console.log(q);

      ss.chanpin.idaorrowIdbselectList(q).then(rd => {

        console.log(rd.obj, '???,,,???')

        this.vw = rd.obj;

        var ss = {
          ywlx: rd.obj.oemType || '',//业务类型  SH或者HK。SH为上海OEM，HK为香港OEM    ****只有从我们这里保存的产品才有****
          wlms: rd.obj.materialDescrition || '',// 物料描述   //产品型号
          jbdw: rd.obj.primaryUom || '',//基本计量单位
          wlz: rd.obj.materialGroupCode || '',//物料组
          jwlh: rd.obj.oldMaterialNumber || '',// 旧物料号
          cpz: rd.obj.department || '',//产品组
          sys: rd.obj.labStudio || '',//实验室/办公室
          wbwlz: rd.obj.extMtlGroup || '',//外部物料组
          sfl: rd.obj.tax || '',//税分类
          cpzch: rd.obj.productRegNum || '',//产品注册号
          cytj: rd.obj.shipCondition || '',//储运条件
          cd: rd.obj.placeOrigin || '',//产地
          cpcc: rd.obj.productHierarchy || '',//产品层次  (关联产品层级编码id)
          scs: rd.obj.manufacturer || '',//生产商
          xwbm: rd.obj.zattr5u || '',//小微编码
          styjsx: rd.obj.ecology || '',//生态硬件属性
          stsr: rd.obj.ecologyIn || '',//生态收入
          youxiaoqi: rd.obj.zcpyxq || '',//产品有效期(年)
          hybzms: rd.obj.industryStdDesc || '',//行业标准描述
          cjrzh: rd.obj.cucode || '',//创建人编码
          wlxh: rd.obj.materialDescrition || '',// 物料描述   //产品型号
          shenpiyijian: rd.obj.zhenshishenpijindu == null ? '' : rd.obj.zhenshishenpijindu.split("_")[2] || '',//审批意见
          serviceProductsType: rd.obj.serviceProductsType,
          mtlGroupCode: rd.obj.mtlGroupCode,
          mtlGroupName: rd.obj.mtlGroupName,
          oemDesc: rd.obj.oemDesc,
          spbmjcmtlgroupname: rd.obj.spbmjcmtlgroupname,
          chainStatus: rd.obj.chainStatus,
          protype: rd.obj.protype,
          materialCode:rd.obj.materialCode,
        }

        this.zy = ss;


      })

    },

    zancunortijiao(q) {


      this.$refs['zy'].validate((valid) => {
        if (valid) {

          var canshu = {

            id: this.chanpinid,//虚拟物料id
            materialCode: this.chanpinid,// 真实物料id里先也存一个虚拟物料id
            oemType: this.zy.ywlx,
            materialDescrition: this.zy.wlxh,
            primaryUom: this.zy.jbdw,
            materialGroupCode: this.zy.wlz,
            oldMaterialNumber: this.zy.jwlh,
            Department: this.zy.cpz,
            labStudio: this.zy.sys,
            extMtlGroup: this.zy.wbwlz,
            Tax: this.zy.sfl,
            productRegNum: this.zy.cpzch,
            shipCondition: this.zy.cytj,
            placeOrigin: this.zy.cd,
            productHierarchy: this.zy.cpcc,
            manufacturer: this.zy.scs,
            zattr5u: this.zy.xwbm,
            ecology: this.zy.styjsx,
            ecologyIn: this.zy.stsr,
            zcpyxq: parseInt(this.zy.youxiaoqi),
            industryStdDesc: this.zy.hybzms,
            cucode: this.zy.cjrzh,
            chongxintijiao: q == 3 ? 1 : null,//3是重新提交

          }


          if (q == 0) {//暂存

            this.zancun(canshu);

          } else {//提交

            this.querentijiao(canshu);

          }


        } else {
          console.log('error submit!!');
          return false;
        }


      });

    },

    querentijiao(q) {

      ss.chanpin.addtijiao(q).then(rd => {

        if (q.chongxintijiao == null) {

          this.$msg.msgs(rd.msg);

          this.fanhui();

        }

      })

    },


    zancun(q) {

      ss.chanpin.addzancun(q).then(rd => {

        this.$msg.msgs(rd.msg);

        this.fanhui();

        this.chanpinid = rd.obj.xuniwuliao;

        var ss = {

          ywlx: rd.obj.oemType,
          wlxh: rd.obj.materialDescrition,
          jbdw: rd.obj.primaryUom,
          wlz: rd.obj.materialGroupCode,
          jwlh: rd.obj.oldMaterialNumber,
          cpz: rd.obj.department,
          sys: rd.obj.labStudio,
          wbwlz: rd.obj.extMtlGroup,
          sfl: rd.obj.tax,
          cpzch: rd.obj.productRegNum,
          cytj: rd.obj.shipCondition,
          cd: rd.obj.placeOrigin,
          cpcc: rd.obj.productHierarchy,
          scs: rd.obj.manufacturer,
          xwbm: rd.obj.zattr5u,
          styjsx: rd.obj.ecology,
          stsr: rd.obj.ecologyIn,
          youxiaoqi: rd.obj.zcpyxq,
          hybzms: rd.obj.industryStdDesc,
          cjrzh: rd.obj.cucode

        }

        this.zy = ss;


      })


    },


    //返回上一页
    fanhui() {

      this.$router.push({path: '/chanp/productManage'});

    },
    showzhezhao() {
      ss.salesList.toshow(this.toshow).then(rd => {
        console.log(rd)
        if (rd == false) {
          this.showOrhide = false;
        } else {
          this.showOrhide = true;
        }
      })
    },
    closeIt() {
      this.showOrhide = false;
      if (this.checked) {
        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
          console.log(rd)
          this.showOrhide = false;
        })
      } else {
        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
          console.log(rd)
          this.showOrhide = false;
        })
      }
    },
    nextStep(i) {
      if (this.status == 1) {
        document.documentElement.scrollTop = 200;
        this.status = 2;
      } else if (this.status == 2) {
        if (this.checked) {
          ss.salesList.toshow(this.toshow, this.checked).then(rd => {
            console.log(rd)
            this.showOrhide = false;
          })
        } else {
          ss.salesList.toshow(this.toshow, this.checked).then(rd => {
            console.log(rd)
            this.showOrhide = false;
          })
        }
      }
    }

  },
  mounted() {

  }
}
</script>

<style scoped>


</style>
<style>
.weekplandetail16 .h-formbLine .el-form-item__label {
  width: 31%;
  text-align: right;
}

.weekplandetail16 .h-formbLine .el-form-item__content {
  width: 69%;
}

.weekplandetail16 .h-formbLine .h-elformWrap-2 {
  width: 33.333%;
  padding-right: 0.5rem
}

.weekplandetail16 .h-formbLine .h-elformWrap-1 .el-form-item__label {
  width: 10%;
}

.weekplandetail16 .h-formbLine .h-elformWrap-1 .el-form-item__content {
  width: 90%;
}

.weekplandetail16 .h-formbLine .el-form-item__content .el-select {
  width: 100% !important;
}
</style>
<style scoped lang="scss">
.bottomTip {
  position: absolute;
  left: 49.7%;
  bottom: 0.3rem;
  transform: translateX(-50%);
}

.newtext {
  font-size: 0.28rem;
  color: white;
  position: absolute;
  top: 0.2rem;
  left: 50%;
  transform: translateX(-50%);
  font-weight: bold;
  text-shadow: 1px 1px 4px #2785E7;
  z-index: 2;
}

.leaderBox {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  z-index: 99999;
  overflow: hidden;
  top: 0;
  left: 0;

  .leaderbg {
    width: 100%;
    height: 100%;
  }

  .steps {
    position: absolute;
    z-index: 1;
  }

  .step1 {
    top: 1.75rem;
    left: 3rem;
    width: 15.5rem;
    height: 6.5rem;
  }

  .step2 {
    top: 7.2rem;
    right: 1.5rem;
    width: 8rem;
    height: 1.5rem;
  }

  .stepbtn {
    width: 1.9rem;
    height: 0.6rem;
    border: 0.03rem solid #FFFFFF;
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    display: flex;
    justify-content: center;
    line-height: 0.5rem;
    position: absolute;
    z-index: 99;
    bottom: 0.65rem;
    left: 50%;
    transform: translateX(-50%);
    font-size: 0.27rem;
    letter-spacing: 2px;
    color: white;
    cursor: pointer;
  }

  .closeIt {
    width: 0.3rem;
    height: 0.3rem;
    position: absolute;
    top: 0.2rem;
    right: 0.2rem;
    cursor: pointer;
  }
}
</style>
